import { Shield, BadgeCheck, Star, Crown } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import { AdvertiserTier } from "@/interfaces/advertisement";

export function TierBadge({ tier }: { tier: AdvertiserTier }) {
  switch (tier) {
    case AdvertiserTier.BASIC:
      return (
        <Badge
          variant="secondary"
          className="flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium"
        >
          <Shield className="w-3.5 h-3.5 opacity-70" />
          Basic
        </Badge>
      );

    case AdvertiserTier.VERIFIED:
      return (
        <Badge className="flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium bg-blue-500/10 text-blue-600 border border-blue-500/20">
          <BadgeCheck className="w-3.5 h-3.5" />
          Verified
        </Badge>
      );

    case AdvertiserTier.TRUSTED:
      return (
        <Badge className="flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium bg-emerald-500/10 text-emerald-600 border border-emerald-500/20">
          <Star className="w-3.5 h-3.5" />
          Trusted
        </Badge>
      );

    case AdvertiserTier.BUSINESS_BASIC:
      return (
        <Badge className="flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-gradient-to-r from-yellow-400/20 via-amber-300/20 to-yellow-500/20 text-yellow-600 border border-yellow-500/30 shadow-sm">
          <Crown className="w-3.5 h-3.5" />
          Elite
        </Badge>
      );

    default:
      return null;
  }
}
